import React, { useState, useEffect } from "react"

export default function GameModal({ show, game, gamesCount, onClose, onSave }) {
  console.log("GameModal rendered, game:", game);
  const [formData, setFormData] = useState({
    game_type: "",
    half: "first",
    needs_askfor: false,
    what_happened: "",
    scene_recap: "",
    askfor_prompt: "",
    prompt_to_cultivate_askfors: "Please convert these batch of suggestions into a json array of strings",
    live_askfor: "",
    presenter: ""
  })

  useEffect(() => {
    if (game) {
      setFormData({
        game_type: game.game_type || "",
        half: game.half || "first",
        needs_askfor: game.needs_askfor || false,
        what_happened: game.what_happened || "",
        scene_recap: game.scene_recap || "",
        askfor_prompt: game.ask_for?.prompt || "",
        prompt_to_cultivate_askfors: game.prompt_to_cultivate_askfors || "Please convert these batch of suggestions into a json array of strings",
        live_askfor: game.live_askfor || "",
        presenter: game.presenter || ""
      })
    } else {
      setFormData({
        game_type: "",
        half: "first",
        needs_askfor: false,
        what_happened: "",
        scene_recap: "",
        askfor_prompt: "",
        prompt_to_cultivate_askfors: "Please convert these batch of suggestions into a json array of strings",
        live_askfor: "",
        presenter: ""
      })
    }
  }, [game])

  const handleSubmit = async (e) => {
    e.preventDefault()

    const nextOrder = game ? game.order_in_show : gamesCount + 1
    const { askfor_prompt, ...gameFields } = formData
    const gameData = {
      show_id: show.id,
      ...gameFields,
      order_in_show: nextOrder,
    }

    const url = game ? `/api/admin/games/${game.id}` : "/api/admin/games"
    const method = game ? "PUT" : "POST"

    try {
      const response = await fetch(url, {
        method,
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector("[name='csrf-token']").content,
        },
        body: JSON.stringify({ game: gameData }),
      })

      if (response.ok) {
        const savedGame = await response.json()

        // If needs_askfor is true and we have a prompt, update the askfor
        if (formData.needs_askfor && formData.askfor_prompt && savedGame.ask_for) {
          await fetch(`/api/admin/ask_fors/${savedGame.ask_for.id}`, {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              "X-CSRF-Token": document.querySelector("[name='csrf-token']").content,
            },
            body: JSON.stringify({
              ask_for: { prompt: formData.askfor_prompt }
            }),
          })
        }

        onSave()
      } else {
        const data = await response.json()
        alert(`Error: ${data.errors?.join(", ")}`)
      }
    } catch (error) {
      console.error("Error saving game:", error)
      alert("Error saving game")
    }
  }

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose()
    }
  }

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
      onClick={handleBackdropClick}
    >
      <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex justify-between items-center mb-6">
            <h3 className="text-2xl font-bold text-gray-800">
              {game ? "Edit Game" : "Add New Game"}
            </h3>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 text-2xl leading-none"
            >
              ×
            </button>
          </div>

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Game Type *
              </label>
              <input
                type="text"
                required
                value={formData.game_type}
                onChange={(e) =>
                  setFormData({ ...formData, game_type: e.target.value })
                }
                placeholder="e.g., Improv, Sketch, Musical"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent text-lg"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Show Half *
              </label>
              <select
                value={formData.half}
                onChange={(e) =>
                  setFormData({ ...formData, half: e.target.value })
                }
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent text-lg bg-white"
              >
                <option value="first">First Half</option>
                <option value="second">Second Half</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Live Askfor
              </label>
              <input
                type="text"
                value={formData.live_askfor}
                onChange={(e) =>
                  setFormData({ ...formData, live_askfor: e.target.value })
                }
                placeholder="Enter live askfor prompt"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Presenter
              </label>
              <select
                value={formData.presenter}
                onChange={(e) =>
                  setFormData({ ...formData, presenter: e.target.value })
                }
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent bg-white"
              >
                <option value="">Select presenter</option>
                <option value="Brendan">Brendan</option>
                <option value="Kenneth">Kenneth</option>
                <option value="Haydn">Haydn</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                What Happened
              </label>
              <textarea
                value={formData.what_happened}
                onChange={(e) =>
                  setFormData({ ...formData, what_happened: e.target.value })
                }
                rows="3"
                placeholder="Brief description of what happened during the game"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Scene Recap
              </label>
              <textarea
                value={formData.scene_recap}
                onChange={(e) =>
                  setFormData({ ...formData, scene_recap: e.target.value })
                }
                rows="4"
                placeholder="Detailed recap of the scene"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
              />
            </div>

            <div className="border border-gray-200 rounded-lg p-4 bg-gray-50">
              <div className="flex items-center">
                <input
                  type="checkbox"
                  id="needs_askfor_modal"
                  checked={formData.needs_askfor}
                  onChange={(e) => {
                    console.log("Checkbox changed:", e.target.checked);
                    const newFormData = {
                      ...formData,
                      needs_askfor: e.target.checked,
                      askfor_prompt: e.target.checked ? formData.askfor_prompt : ""
                    };
                    console.log("New form data:", newFormData);
                    setFormData(newFormData);
                  }}
                  className="h-5 w-5 text-purple-600 focus:ring-purple-500 border-gray-300 rounded"
                />
                <label
                  htmlFor="needs_askfor_modal"
                  className="ml-3 block text-sm font-medium text-gray-700"
                >
                  Needs Ask For
                </label>
              </div>

              {console.log("Rendering conditional, needs_askfor:", formData.needs_askfor)}
              {formData.needs_askfor && (
                <div className="mt-4 space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Ask For Prompt *
                    </label>
                    <input
                      type="text"
                      required={formData.needs_askfor}
                      value={formData.askfor_prompt}
                      onChange={(e) =>
                        setFormData({ ...formData, askfor_prompt: e.target.value })
                      }
                      placeholder="e.g., A profession, An object, A location"
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent bg-white"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      ChatGPT Cultivation Prompt
                    </label>
                    <textarea
                      value={formData.prompt_to_cultivate_askfors}
                      onChange={(e) =>
                        setFormData({ ...formData, prompt_to_cultivate_askfors: e.target.value })
                      }
                      rows="3"
                      placeholder="Prompt for ChatGPT to format suggestions"
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent bg-white text-sm"
                    />
                    <p className="mt-1 text-xs text-gray-500">
                      This prompt is used by ChatGPT to convert audience suggestions into formatted items
                    </p>
                  </div>
                </div>
              )}
            </div>

            <div className="flex gap-3 pt-4">
              <button
                type="submit"
                className="flex-1 px-6 py-3 bg-purple-500 hover:bg-purple-600 text-white rounded-lg font-semibold text-lg transition-colors"
              >
                {game ? "Update Game" : "Add Game"}
              </button>
              <button
                type="button"
                onClick={onClose}
                className="px-6 py-3 bg-gray-300 hover:bg-gray-400 text-gray-800 rounded-lg font-semibold text-lg transition-colors"
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}
